// extracted by mini-css-extract-plugin
export default {"openInLine":"OpenInLINE_openInLine__NXUIF","description":"OpenInLINE_description__NEADj","instruction":"OpenInLINE_instruction__5pRm1"};